<template>
  <navigator-home>
    <div class="database_login">
      <h3 class="login-title">登录数据库</h3>
      <el-form ref="form" label-width="108px" :model="form" :rules="formRules">
        <el-form-item label="实例名称">
          <el-input disabled v-model="instanceInfo.instanceName"></el-input>
        </el-form-item>
        <el-form-item label="实例ID">
          <el-input disabled v-model="instanceInfo.InstanceId"></el-input>
        </el-form-item>
        <el-form-item label="验证数据库" v-if="instanceInfo.ServiceType === 'mongodb'">
          <el-input v-model="form.verifyDatabase" placeholder="请输入验证数据库"></el-input>
        </el-form-item>
        <el-form-item
          label="用户名"
          prop="username"
          v-show="instanceInfo.ServiceType !== 'redis'"
          :required="instanceInfo.ServiceType !== 'redis'"
        >
          <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="form.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="isTesting" @click="onTestConnection">
            连通性测试
          </el-button>
          <el-button type="primary" :disabled="!isTested"  @click="onSubmit">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </navigator-home>
</template>

<script>
import { reqLoginInstance } from '@/api/source';
import { ISourceInfo } from '@/config/interfaces';
import NavigatorHome from './NavigatorHome';
import { ss } from '@/utils/storage';
import { SOURCES_CONFIG } from '@/config/variables';
import Md5 from 'md5';

export default {
  name: "Login",

  components: {
    NavigatorHome,
  },

  data() {
    const usernameValidator = (rule, value, callback) => {
      if (this.instanceInfo.ServiceType !== 'redis') {
        if (!value) {
          callback(new Error('用户名必填'));
          return;
        }
      }
      callback();
    };

    return {
      isTesting: false,
      isTested: false,
      instanceInfo: {},
      form: {
        username: '',
        password: '',
        verifyDatabase: ''
      },
      formRules: {
        username: [{ validator: usernameValidator}],
        password: [{ required: true, message: '密码必填'}]
      },
      sourceInfo: null,
      RegionId: '',
      dbType: {
        mysql: 'mysql',
        mongodb: 'mongo',
        redis: 'redis'
      }
    };
  },
  created() {
    let queryObj = this.$route.query;
    this.RegionId = queryObj.RegionId;
    this.instanceInfo.instanceName = queryObj.instanceName;
    this.instanceInfo.InstanceId = queryObj.InstanceId;
    this.instanceInfo.ServiceType = queryObj.ServiceType;
    this.instanceInfo.ServicePort = queryObj.ServicePort;
    this.instanceInfo.ServiceEdition = queryObj.ServiceEdition;
  },
  methods: {
    /**
     * 连通性测试，通过后获取 dataSourceId
     */
    async onTestConnection() {
      try {
        await this.$refs.form.validate();
      } catch (e) {
        this.$message.warning('请完善所有表单项');
        return;
      }

      try {
        let dbType = this.instanceInfo.ServiceType;
        this.isTesting = true;

        const reqData = {
          RegionId: this.RegionId,
          InstanceId: this.instanceInfo.InstanceId,
          //serName: this.form.username,
          Password: this.form.password,
          Port: this.instanceInfo.ServicePort
        };

        if (['mysql', 'mongodb'].includes(this.instanceInfo.ServiceType)) {
          reqData.UserName = this.form.username;
        }
        if(this.instanceInfo.ServiceType === 'mongodb')
        {
          reqData.AuthDataBase = this.form.verifyDatabase ? this.form.verifyDatabase: undefined
        }

        const res = await reqLoginInstance(this.dbType[dbType], reqData);

        if (res.data.code !== 'success') {
          this.$message.error('请检查您的用户名或密码');
          return;
        }

        const sourceInfo = new ISourceInfo({
          connToken: res.data.data,
          instanceName: this.instanceInfo.instanceName,
          instanceType: this.instanceInfo.ServiceType,
          RegionId: this.RegionId,
          InstanceId: this.instanceInfo.InstanceId,
          ServicePort: this.instanceInfo.ServicePort,
          ServiceEdition: this.instanceInfo.ServiceEdition
        });
        this.sourceInfo = { ...sourceInfo };

        this.isTested = true;
        this.$message.success('测试通过');
      } catch (e) {
        this.isTested = false;
        this.$message.error('连接失败，请重试');
      } finally {
        this.isTesting = false;
      }
    },
    /**
     * 登录数据库
     */
    onSubmit() {
      const token = Md5(JSON.stringify(this.sourceInfo) + +new Date());
      ss.set(token, this.sourceInfo);
      //this.sourceInfo.mark
      /*const { href } = this.$router.resolve({
        name: SOURCES_CONFIG[this.sourceInfo.mark].indexRouteName,
        query: { db_sign: token }
      });*/
      //window.location.replace(href);
      this.$router.push({
        name: SOURCES_CONFIG[this.sourceInfo.mark].indexRouteName,
        query: { db_sign: token }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.database_login{
  width: 30%;
  min-width: 500px;
  margin: 0 auto;
  .login-title{
    margin-top: 20%;
  }
}
</style>
